import { lazy } from "react";
import { ALLOWED_MODULES } from "../../constants/enums";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
// Assuming this is the correct path for your constant
import { CROSSROADS_LEADS_ROUTE } from "./crossroadsleads.constant";

const CrossroadsLeadsList = Loadable(
    lazy(() =>
        import("./CrossroadsLeadsList").then(({ CrossroadsLeadsList }) => ({
            default: CrossroadsLeadsList,
        }))
    )
);

const ManageCrossroadsLeads = Loadable(
    lazy(() =>
        import("./ManageCrossroadsLeads").then(({ ManageCrossroadsLeads }) => ({
            default: ManageCrossroadsLeads,
        }))
    )
);

export const crossroadsLeadsRoutes = [
    {
        path: CROSSROADS_LEADS_ROUTE,
        exact: true,
        element: (
            <AuthorizedRoute
                
                moduleIds={[ALLOWED_MODULES.CAMPAIGN_LEAD]}
            >
                <CrossroadsLeadsList />
            </AuthorizedRoute>
        ),
    },
    {
        /* CREATE Lead */
        path: `${CROSSROADS_LEADS_ROUTE}/manage`,
        exact: true,
        element: (
            <AuthorizedRoute
              
                moduleIds={[ALLOWED_MODULES.CAMPAIGN_LEAD]}
            >
                <ManageCrossroadsLeads />
            </AuthorizedRoute>
        ),
    },
    {
        /* EDIT Lead */
        path: `${CROSSROADS_LEADS_ROUTE}/manage/:uuid`,
        exact: true,
        element: (
            <AuthorizedRoute
                
                
                moduleIds={[ALLOWED_MODULES.CAMPAIGN_LEAD]}
            >
                <ManageCrossroadsLeads />
            </AuthorizedRoute>
        ),
    },

  
];